import { SpeckleApp } from "lib/types/speckle/SpeckleApp";
import SpeckleLogoSvg from "../../speckle-logo.svg";
import Card from "components/elements/Card/Card";

export function SpeckleServerCard(p: {
  app: SpeckleApp;
  beginAuth: () => void;
}) {
  return (
    <Card>
      <button
        type="button"
        className="flex w-full flex-row p-2 hover:bg-gray-50"
        onClick={() => p.beginAuth()}
      >
        <div className="m-1 w-12 p-2">
          <SpeckleLogoSvg />
        </div>
        <div className=" ml-2 cursor-default space-y-1 text-left font-light">
          <h1 className="text-neutral-700">{p.app.name ?? "Speckle Server"}</h1>
          <div className="grid grid-cols-4 divide-x divide-stone-300 rounded-md bg-neutral-100 p-1 text-xxs text-neutral-700">
            <p className=" px-2">Server Url</p>
            <p className="col-span-3 px-2">{p.app.serverUrl}</p>
          </div>
        </div>
      </button>
    </Card>
  );
}
